import type { Middleware } from 'openapi-fetch';

import { i18next } from '@/lib/i18n/adapters/i18next';

/** 選択中の言語を Accept-Language として全 API リクエストに付与する（呼び出し側指定を優先）。 */
export const createAcceptLanguageMiddleware = (): Middleware => ({
  onRequest({ request }) {
    const language = i18next.language;
    if (language && !request.headers.has('Accept-Language')) {
      request.headers.set('Accept-Language', language);
    }
    return request;
  },
});
